module.exports = __webpack_public_path__ + "static/media/up.d01ebac5.svg";